/**
 * The top bar's action zone belongs to whichever screen is open: the reader puts its tool islands there
 * (move to folder, topics, copy, read, briefing, appearance, Details), the settings shell its New /
 * Duplicate / Archive / Save tools. A screen renders `<TopbarActions>…</TopbarActions>` anywhere in its
 * tree; the content is portalled into the bar.
 */

import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export const TopbarSlotContext = createContext<HTMLElement | null>(null);

export function TopbarActions({ children }: { children: ReactNode }) {
  const slot = useContext(TopbarSlotContext);
  return slot ? createPortal(children, slot) : null;
}
